import styled from "styled-components";

export const AddEditTaskContainer = styled.div`
    width:100%;
    @media(max-width:640px) {
        width: 100%;
    }
    padding:0 20px;
    box-sizing:border-box;
`;

export const AddEditModalHeader = styled.div`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-bottom: transparent;
    padding:20px 20px 0;
`;

export const InputTitle = styled.div`
    color: #302F2F;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;